/**
 * @huaca/ui design system entry. Imported once per app: `import '@huaca/ui/styles.css'`.
 * Order matters: tokens (custom properties + fonts) → base (reset/elements/layout) → components
 * → rail (the shell's side navigation) → type (script-aware typography; imported LAST so its
 * Hebrew/Latin overrides win).
 */
@import './tokens.css';
@import './base.css';
@import './components.css';
@import './rail.css';
@import './type.css';
